import * as XLSX from "xlsx";

export const exportChartDataToExcel = ({ title, categories, series, lang }) => {
  const arabic = !String(lang || "ar").toLowerCase().startsWith("en");
  const categoryHeader = arabic ? "التصنيف" : "Category";
  const totalLabel = arabic ? "المجموع" : "Total";
  const safeSeries = Array.isArray(series) ? series : [];
  const safeCategories = Array.isArray(categories) ? categories : [];

  const headers = [categoryHeader, ...safeSeries.map((item) => item.name || "")];
  const rows = safeCategories.map((category, index) => [
    category,
    ...safeSeries.map((item) => item.data?.[index] ?? 0),
  ]);
  const totals = [
    totalLabel,
    ...safeSeries.map((item) =>
      (item.data || []).reduce((sum, value) => sum + (Number(value) || 0), 0)
    ),
  ];

  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows, totals]);
  if (arabic) {
    worksheet["!dir"] = "rtl";
  }

  headers.forEach((_, columnIndex) => {
    const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: columnIndex })];
    if (cell) {
      cell.s = { font: { bold: true } };
    }
  });

  const colWidths = headers.map((header, columnIndex) => {
    let maxLen = String(header || "").length;
    rows.forEach((row) => {
      maxLen = Math.max(maxLen, String(row[columnIndex] ?? "").length);
    });
    maxLen = Math.max(maxLen, String(totals[columnIndex] ?? "").length);
    return { wch: Math.min(40, maxLen + 2) };
  });
  worksheet["!cols"] = colWidths;

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, arabic ? "البيانات" : "Data");
  const stamp = new Date();
  const pad = (value) => String(value).padStart(2, "0");
  const filename = `${(title || "chart").replace(/[\\/:*?"<>|]/g, "_")}_${stamp.getFullYear()}${pad(
    stamp.getMonth() + 1
  )}${pad(stamp.getDate())}_${pad(stamp.getHours())}${pad(stamp.getMinutes())}.xlsx`;
  XLSX.writeFile(workbook, filename);
};
